/**
 * CanShareFilesUseCase
 *
 * Checks whether the current browser/platform supports sharing
 * the given files via the Web Share API.
 */

class CanShareFilesUseCase {
  execute(files: File[]): boolean {
    return navigator.canShare?.({ files }) ?? false;
  }
}

export const canShareFilesUseCase = new CanShareFilesUseCase();
